import { Buffer } from 'buffer';
import process from 'process';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'blueimp-canvas-to-blob';
import AudioRecorder from 'audio-recorder-polyfill';

import { init as initSentry } from 'shared/utils/sentry/sentry';
import App from './app/App';
import 'index.css';

(window as any).Buffer = Buffer;
(window as any).process = process;

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container!);

const render = () => {
  root.render(<App />);
};

initSentry();

render();

if (!window.MediaRecorder) {
  window.MediaRecorder = AudioRecorder;
}

if (module.hot) {
  module.hot.accept('app/App', () => {
    render();
  });
}
